import {IsAuthenticated, useCurrentUser} from '@visma/react-keycloak';
import {useKeycloak} from '@react-keycloak/web';
import {generatePath, Redirect} from "react-router-dom";
import {path as application} from "./application";
import NotFound from "@super-template/core/src/NotFound";
import {useEffect} from "react";

export default () => {
  return (
    <IsAuthenticated fallback={<LogIn/>}>
      <Authenticated/>
    </IsAuthenticated>
  )
}

/**
 * @return {null}
 */
function LogIn() {
  const {keycloak} = useKeycloak();
  useEffect(() => {
    keycloak.login();
  }, [keycloak]);

  return null;
}

function Authenticated() {
  const organization = useCurrentUser().tenant;
  return organization ? <Redirect to={generatePath(application, {organization})}/> : <NotFound/>;
}
